import { useTranslations } from "next-intl";
const useWowOfferTranslations = () => {
  const t = useTranslations('Shared');
  const hotelActive = process.env.NEXT_PUBLIC_ACTIVE_WOW_OFFER_HOTEL === "true";
  const flightActive = process.env.NEXT_PUBLIC_ACTIVE_WOW_OFFER_FLIGHT === "true";
  const carActive = process.env.NEXT_PUBLIC_ACTIVE_WOW_OFFER_CAR === "true";
  const isAnyActive = hotelActive || flightActive || carActive;
  const isAllActive = hotelActive && flightActive && carActive;
  const getUtilityModalTranslations = () => {
    if (!isAllActive && hotelActive) {
      return {
        title: t("UTILITY_MODAL.HOTEL.TITLE"),
        description: t("UTILITY_MODAL.HOTEL.DESCRIPTION"),
        button: t("UTILITY_MODAL.HOTEL.BUTTON"),
        link: t("UTILITY_MODAL.HOTEL.LINK")
      };
    }
    return {
      title: t("UTILITY_MODAL.GENERAL.TITLE"),
      description: t("UTILITY_MODAL.GENERAL.DESCRIPTION"),
      button: t("UTILITY_MODAL.GENERAL.BUTTON"),
      link: t("UTILITY_MODAL.GENERAL.LINK")
    };
  };
  return {
    utilityModal: getUtilityModalTranslations(),
    isAllActive,
    isAnyActive,
    isHotelActive: hotelActive,
    isFlightActive: flightActive,
    isCarActive: carActive
  };
};
export default useWowOfferTranslations;